export default __webpack_public_path__ + "static/media/iPhone11_soylistoapp.3e84a68c.png";